const wording = {
  accountMenuLabel: 'Votre compte',
  displayNamePrefix: 'Bonjour',
  logoutLabel: 'se déconnecter',
};

export default wording;
